/*
 * サブシステム名：
 * 機能名：受注・実績一覧
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdTextBox from '@/components/DdTextBox'
import DdRadioButton from '@/components/DdRadioButton'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdDataTable from '@/components/DdDataTable'
import DdFooterButton from '@/components/DdFooterButton'
import DdHacchuKensakuTextBox from '@/components/DdHacchuKensakuTextBox'
import DdCheckbox from '@/components/DdCheckbox'
import DdDropDown from '@/components/DdDropDown'

import flowMixin from '@/mixins/flowMixins'

import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import validators from '@/rahmen/validators'

import header from '@/ddv2.library/header'

export default {
  name: 'PrmHaishaList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      eigyoshoCd: '',
      jomuinCd: '',
      tokuisakiCd: '',
      unkoYoteiStartYmdString: '',
      unkoYoteiEndYmdString: '',
      haishaTantoshaCd: '',
      sharyoId: '',
      hacchusakiCd: '',
      unkoJissekiNo: '',
      sharyoGroupSbt1: '',
      sharyoGroupSbt2: '',
      haishaStatusKbn: '',
      haishasakiKbn: '',
      jissekiTorokuKbn: '',
      meisaiHeadFlg: false
    },
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdSubHeader,
    DdCodeTextBox,
    DdDateBox,
    DdHacchuKensakuTextBox,
    DdTextBox,
    DdRadioButton,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdDataTable,
    DdFooterButton,
    DdCheckbox,
    DdDropDown
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      jininList: 'DDMasters/mstJinin',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      sharyoList: 'DDMasters/vwCMstSharyo',
      shubetsuList: 'DDMasters/mstShubetsu',
      usersEigyoshoCd: 'users/eigyoshoCd'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.unkoYoteiYmdDisp = elem.unkoYoteiYmd ? filter.dateFormatter(elem.unkoYoteiYmd) : ''
        if (elem.jissekiTorokuFlg != null) {
          if (elem.jissekiTorokuFlg) {
            elem.jissekiTorokuKbnDisp = '実績'
          /* } else {
            if (elem.haishaKakuteiFlg != null) {
              elem.jissekiTorokuKbnDisp = elem.haishaKakuteiFlg ? '配車' : '予定'
            } */
          }
        }
        elem.juchuSuryoDisp = elem.juchuSuryo === 0 || elem.juchuSuryo ? filter.numericFormatter(elem.juchuSuryo) : null
        elem.juchuJuryoDisp = elem.juchuJuryo === 0 || elem.juchuJuryo ? filter.numericFormatter(elem.juchuJuryo) : null
        elem.hatsuchiYmdDisp = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : ''
        elem.chakuchiYmdDisp = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : ''
        return elem
      })
    },
    // 受注営業所フィルター
    filteredJuchuEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 人員フィルター
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 配車担当者フィルター
    filteredHaishaTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 取引先フィルター
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 得意先フィルター
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 傭車先フィルター
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 発着地フィルター
    filteredMstHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 車輛マスタフィルター
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.hacchusakiFlg === false
      })
    },
    // 車輛グループフィルター
    filteredSharyoGroupShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI012')
    },
    // CSVボタン活性条件
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    // 追加ボタン活性条件
    CreateButtonDisp () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'msthacchakuchi', 'vwcmstsharyo', 'mstshubetsu', 'mstjinin'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.defineHeaderPromise')
            this.headers = [
              { text: '運行実績No', value: 'unkoJissekiNo' },
              { text: '運行予定日', value: 'unkoYoteiYmdDisp' },
              { text: '実績', value: 'jissekiTorokuKbnDisp', align: 'center' },
              { text: '営業所', value: 'eigyoshoNm' },
              { text: '配車先区分', value: 'haishasakiNm' },
              { text: '配車担当者', value: 'haishaTantoshaNm' },
              { text: '傭車先', value: 'hacchusakiNm' },
              { text: '車両番号', value: 'sharyoNo' },
              { text: '車両ナンバープレート', value: 'sharyoNoPlate' },
              { text: '乗務員', value: 'jomuinNm' },
              { text: '明細', value: 'juchuMeisaiNo' },
              { text: '得意先', value: 'tokuisakiNm' },
              { text: '発地', value: 'hatsuchiNm' },
              { text: '発地年月日', value: 'hatsuchiYmdDisp' },
              { text: '発地時刻', value: 'hatsuchiHmsDisp' },
              { text: '着地', value: 'chakuchiNm' },
              { text: '着地年月日', value: 'chakuchiYmdDisp' },
              { text: '着地時刻', value: 'chakuchiHmsDisp' },
              { text: '品名', value: 'hinmeiNm' },
              { text: '数量', value: 'juchuSuryoDisp', align: 'end' },
              { text: '単位', value: 'tanniNm' },
              { text: '重量(t)', value: 'juchuJuryoDisp', align: 'end' },
              { text: '経由地１', value: 'keiyuchi1Nm' },
              { text: '経由地２', value: 'keiyuchi2Nm' },
              { text: '経由地３', value: 'keiyuchi3Nm' },
              { text: '経由地４', value: 'keiyuchi4Nm' },
              { text: '経由地５', value: 'keiyuchi5Nm' }]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              eigyoshoCd: self.usersEigyoshoCd,
              jomuinCd: '',
              tokuisakiCd: '',
              unkoYoteiStartYmdString: filter.dateFormatter(new Date()),
              unkoYoteiEndYmdString: filter.dateFormatter(new Date()),
              haishaTantoshaCd: '',
              sharyoId: '',
              hacchusakiCd: '',
              unkoJissekiNo: '',
              sharyoGroupSbt1: '',
              sharyoGroupSbt2: '',
              haishaStatusKbn: '01',
              haishasakiKbn: '01',
              jissekiTorokuKbn: '01',
              meisaiHeadFlg: false
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmHaishaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('PrmHaishaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmHaishaList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmHaishaList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmHaishaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      var path = null
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            var strBool = typeof self.conditions.meisaiHeadFlg
            if (strBool === 'string') {
              var headFlg = self.conditions.meisaiHeadFlg
            } else {
              headFlg = self.conditions.meisaiHeadFlg.toString()
            }
            if (headFlg === 'true') {
              path = '/api/v1/D2PRMD0010/SearchHead'
            } else if (headFlg === 'false') {
              path = '/api/v1/D2PRMD0010/SearchFull'
            }
            self.HttpClient.post(path, self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            haishaStatusKbn: self.conditions.haishaStatusKbn,
            haishasakiKbn: self.conditions.haishasakiKbn,
            jissekiTorokuKbn: self.conditions.jissekiTorokuKbn,
            meisaiHeadFlg: self.conditions.meisaiHeadFlg
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.clearInputsPromise')
            this.conditions = {
              eigyoshoCd: this.usersEigyoshoCd,
              jomuinCd: '',
              tokuisakiCd: '',
              unkoYoteiStartYmdString: filter.dateFormatter(new Date()),
              unkoYoteiEndYmdString: filter.dateFormatter(new Date()),
              haishaTantoshaCd: '',
              sharyoId: '',
              hacchusakiCd: '',
              unkoJissekiNo: '',
              sharyoGroupSbt1: '',
              sharyoGroupSbt2: '',
              haishaStatusKbn: '01',
              haishasakiKbn: '01',
              jissekiTorokuKbn: '01',
              meisaiHeadFlg: false
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id })
    },
    onCsvButtonClick: function (e) {
      var path = null
      var strBool = typeof this.conditions.meisaiHeadFlg
      if (strBool === 'string') {
        var headFlg = this.conditions.meisaiHeadFlg
      } else {
        headFlg = this.conditions.meisaiHeadFlg.toString()
      }
      if (headFlg === 'true') {
        path = '/api/v1/D2PRMD0010/HeadCsvDownload'
      } else if (headFlg === 'false') {
        path = '/api/v1/D2PRMD0010/FullCsvDownload'
      }
      this.HttpClient
        .post(path, this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    // 検索前チェック
    searchValidate: function () {
      if (!this.conditions.eigyoshoCd && !this.conditions.jomuinCd && !this.conditions.tokuisakiCd && !this.conditions.unkoYoteiStartYmdString && !this.conditions.unkoYoteiEndYmdString && !this.conditions.haishaTantoshaCd && !this.conditions.sharyoId && !this.conditions.hacchusakiCd && !this.conditions.unkoJissekiNo && !this.conditions.sharyoGroupSbt1 && !this.conditions.sharyoGroupSbt2 && this.conditions.haishaStatusKbn === '01' && this.conditions.haishasakiKbn === '01' && this.conditions.jissekiTorokuKbn === '01' && !this.conditions.meisaiHeadFlg) {
        this.setInvalidSummaryMessage('COME0026')
        return false
      }
      // 運行予定年月日不整合チェック
      if (this.conditions.unkoYoteiStartYmdString && this.conditions.unkoYoteiEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.unkoYoteiStartYmdString, this.conditions.unkoYoteiEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.unkoYoteiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.unkoYoteiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    }
  }
}
